import React, { Component } from 'react'

const style = require('./LoadingContent.css')

const WIDTH = '100%'
const HEIGHT = '16px'

const DEFAULT_BG_COLOR = '#EEEEEE'
const WHITE = "#FFF"

const DEFAULT_BORDER_RADIUS = '8px'
const HALF = "50%"
const SHARPER = "6px"
const ROUNDER = "12.5px"

interface Props {
  width?: string,
  height?: string,
  borderRadius?: string,
  border?: string,
  lightBGColor?: boolean,
}

export class LoadingContent extends Component<Props> {
  static defaultProps = {
    width: WIDTH,
    height: HEIGHT,
    bgColor: DEFAULT_BORDER_RADIUS,
  }

  get contentStyle() {
    return {
      background: `linear-gradient(to right, ${this.getBGColor()} 8%, #DDD 18%, ${this.getBGColor()} 33%)`, // eslint-disable-line max-len
      width: this.props.width,
      height: this.props.height,
      borderRadius: this.getBorderRadius(),
      border: this.props.border,
      backgroundSize: '900px 1px',
    }
  }

  getBGColor() {
    if (!this.props.border) {
      return this.props.lightBGColor ? WHITE : DEFAULT_BG_COLOR
    }
    return 'none'
  }

  getBorderRadius() {
    switch (this.props.borderRadius) {
      case "half":
        return HALF
      case "rounder":
        return ROUNDER
      case "sharper":
        return SHARPER
      default:
        return DEFAULT_BORDER_RADIUS
    }
  }

  render() {
    return (
      <div className={style.animatedMask} style={this.contentStyle} />
    )
  }
}
